import React from 'react';

export default class ArticleTwo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        return (
            <article id={this.props.id} className='content-article article-contact'>
                <div>
                    <h2>Contact Us</h2>
                    <p>
                        Thank you for your interest in Odisea Catamarans. We pride ourselves on manufacturing the highest quality units.
                        Attention to detail and the ultimate standards in quality is our aim. Please contact us for more details.
                    </p>
                    <h3 className='normal-case'>
                        <a href='mailto:Info@odiseacatamarans.com?subject=Odisea Catamarans Enquiry'>Get in touch today</a>
                    </h3>
                </div>
            </article>
        );
    }
}